(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dagira-card-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dagira-card-gallery')) {
 class DagiraCardGallery extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController();
   const options = {signal:this.controller.signal};
   this.frames = [...this.querySelectorAll('.dg-card-frame')];
   this.card = this.closest('.dg-card');
   this.index = 0; this.requested = 0; this.serial = 0; this.manual = false;
   this.styling = this.frames.findIndex(frame => frame.hasAttribute('data-styling'));
   this.querySelector('.dg-card-controls').hidden = this.frames.length < 2;
   this.paint(0);
   this.card.addEventListener('pointerenter', event => {
    if (event.pointerType === 'mouse' && matchMedia('(hover:hover) and (pointer:fine)').matches) this.preview(140);
   }, options);
   this.card.addEventListener('pointerleave', () => {
    if (!this.card.contains(document.activeElement)) this.restore();
   }, options);
   this.card.addEventListener('focusin', event => {
    if (event.target.closest('button')) clearTimeout(this.hoverTimer);
   }, options);
   this.card.addEventListener('focusout', event => {
    if (!this.card.contains(event.relatedTarget)) this.restore();
   }, options);
   this.addEventListener('click', event => {
    const button = event.target.closest('[data-card-step]');
    if (!button) return;
    event.preventDefault(); event.stopPropagation();
    this.step(Number(button.dataset.cardStep));
   }, options);
   this.card.addEventListener('keydown', event => {
    if (event.altKey || event.ctrlKey || event.metaKey) return;
    if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    this.step(event.key === 'ArrowRight' ? 1 : -1);
   }, options);
  }
  disconnectedCallback() {
   clearTimeout(this.hoverTimer); this.serial++;
   this.controller?.abort(); this.controller = null;
  }
  preview(delay) {
   if (this.manual || this.styling < 0) return;
   clearTimeout(this.hoverTimer);
   this.hoverTimer = setTimeout(() => this.show(this.styling, false), delay);
  }
  restore() {
   clearTimeout(this.hoverTimer);
   if (!this.manual) this.show(0, false);
  }
  step(direction) {
   clearTimeout(this.hoverTimer); this.manual = true;
   this.show((this.requested + direction + this.frames.length) % this.frames.length, true);
  }
  async ready(image) {
   image.loading = 'eager';
   if (!image.complete) await new Promise((resolve,reject) => {
    const finish = ok => {
     clearTimeout(timer); image.removeEventListener('load',loaded); image.removeEventListener('error',failed);
     ok ? resolve() : reject(new Error('image unavailable'));
    };
    const loaded = () => finish(true), failed = () => finish(false);
    const timer = setTimeout(failed,12000);
    image.addEventListener('load',loaded,{once:true}); image.addEventListener('error',failed,{once:true});
    if (image.complete) finish(image.naturalWidth > 0);
   });
   if (!image.naturalWidth) throw new Error('image unavailable');
   if (image.decode) await image.decode();
  }
  async show(index, announce) {
   this.requested = index;
   const serial = ++this.serial;
   try {
    const frame = this.frames[index];
    const template = frame.querySelector('template');
    if (template) { frame.append(template.content.cloneNode(true)); template.remove(); }
    await this.ready(frame.querySelector('img'));
    if (serial !== this.serial || !this.isConnected) return;
    this.index = index; this.paint(index);
    if (announce) this.querySelector('.dg-card-announcement').textContent = `${index+1} / ${this.frames.length}. ${this.frames[index].querySelector('img').alt}`;
   } catch {
    if (serial !== this.serial) return;
    this.requested = this.index;
    if (announce) this.querySelector('.dg-card-announcement').textContent = this.dataset.error;
   }
  }
  paint(index) {
   this.frames.forEach((frame,i) => {
    frame.classList.toggle('is-current', i === index);
    frame.setAttribute('aria-hidden',String(i !== index));
   });
   this.querySelector('.dg-card-count').textContent = `${index+1} / ${this.frames.length}`;
  }
 }
 customElements.define('dagira-card-gallery',DagiraCardGallery);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dagira-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dagira-gallery')) {
 class DagiraGallery extends HTMLElement {
  connectedCallback() {
   if (this.ready) {this.resize?.observe(this.track);return;}
   this.ready = true;
   this.track = this.querySelector('.dg-gallery-track');
   this.slides = [...this.querySelectorAll('.dg-gallery-slide')];
   this.thumbs = [...this.querySelectorAll('[data-photo-index]')];
   this.index = 0;
   this.addEventListener('click', event => {
    const thumb = event.target.closest('[data-photo-index]');
    const arrow = event.target.closest('[data-direction]');
    if (thumb) this.go(Number(thumb.dataset.photoIndex));
    if (arrow) this.go(this.index + Number(arrow.dataset.direction));
   });
   this.addEventListener('keydown', event => {
    if (event.altKey || event.ctrlKey || event.metaKey) return;
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    event.preventDefault();
    this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
   });
   this.track.addEventListener('scroll', () => {
    if (!this.track.clientWidth) return;
    this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / this.track.clientWidth)));
    this.update();
   }, {passive:true});
   this.resize = new ResizeObserver(() => {
    if (this.track.clientWidth) this.track.scrollTo({left:this.index * this.track.clientWidth, behavior:'instant'});
   });
   this.resize.observe(this.track);
   this.update();
  }
  disconnectedCallback() {this.resize?.disconnect();}
  go(index) {
   this.index = Math.max(0, Math.min(this.slides.length - 1, index));
   const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
   this.track.scrollTo({left:this.index * this.track.clientWidth,behavior:reduce?'instant':'smooth'});
   this.update();
  }
  update() {
   this.thumbs.forEach((button,i) => {if(i === this.index) button.setAttribute('aria-current','true'); else button.removeAttribute('aria-current');});
   this.querySelector('[data-direction="-1"]').disabled = this.index === 0;
   this.querySelector('[data-direction="1"]').disabled = this.index === this.slides.length - 1;
   this.querySelector('.dg-gallery-count').textContent = `${this.index + 1} / ${this.slides.length}`;
  }
 }
 customElements.define('dagira-gallery',DagiraGallery);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dagira-hover"] && !Shopify.designMode) return;
  try {
    (() => {
 function prepare(root = document) {
  root.querySelectorAll('.dg-card-alternate, .dg-native-worn img').forEach(image => {
   if (image.dataset.dgObserved) return;
   image.dataset.dgObserved = 'true';
   const frame = image.closest('.dg-card-image') || image.closest('.dg-native-worn');
   if (!frame) return;
   const ready = () => {
    if (!image.naturalWidth) return;
    if (typeof image.decode === 'function') image.decode().then(() => frame.classList.add('dg-image-ready')).catch(() => {});
    else frame.classList.add('dg-image-ready');
   };
   image.addEventListener('load', ready);
   image.addEventListener('error', () => frame.classList.remove('dg-image-ready'));
   if (image.complete) ready();
  });
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepare(), {once:true});
 else prepare();
 document.addEventListener('shopify:section:load', event => prepare(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
